<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2">
        <div class="p-10">
            <div class="font-600 font-size-20px line-h-40 color-base-1700">
                {{"LoyaltyPoints" | translate }}
            </div>

            <div class="card-slider mt-10 p-10">
                <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                    <ng-template carouselSlide>
                        <div class="card mt-10">
                            <!-- <span class="active-text-box">
                                card active
                            </span> -->
                            <div class="img-box">
                                <img src="../../assets/images/bg-loyalty-card-slider.jpg" alt="">
                                <div class="text-box text-align-center">
                                    <div
                                        class="font-400 font-size-12px line-h-20 letter-spacing-1 text-uppercase color-base-100">
                                        {{"ImtiazTitaniumCreditCard" | translate}}
                                    </div>
                                    <div
                                        class="font-400 font-size-10px line-h-20 letter-spacing-1 text-uppercase color-base-100 mt-5">
                                        5270 17•• •••• 4924
                                    </div>
                                    <div
                                        class="font-600 font-size-24px line-h-28 letter-spacing-03 text-uppercase color-base-100 mt-20">
                                        450,383
                                    </div>
                                    <div
                                        class="font-400 font-size-12px line-h-18 letter-spacing-1 text-uppercase color-base-100">
                                        {{"LoyaltyPoints" | translate}}
                                    </div>
                                    <button class="btn-dft-border mt-30" (click)="showModal(2)">
                                        {{"REDEEMNOW" | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class="card mt-10">
                            <!-- <span class="active-text-box">
                                card active
                            </span> -->
                            <div class="img-box">
                                <img src="../../assets/images/bg-loyalty-card-slider.jpg" alt="">
                                <div class="text-box text-align-center">
                                    <div
                                        class="font-400 font-size-12px line-h-20 letter-spacing-1 text-uppercase color-base-100">
                                        {{"ImtiazTitaniumCreditCard" | translate}}
                                    </div>
                                    <div
                                        class="font-400 font-size-10px line-h-20 letter-spacing-1 text-uppercase color-base-100 mt-5">
                                        5270 17•• •••• 4924
                                    </div>
                                    <div
                                        class="font-600 font-size-24px line-h-28 letter-spacing-03 text-uppercase color-base-100 mt-20">
                                        450,383
                                    </div>
                                    <div
                                        class="font-400 font-size-12px line-h-18 letter-spacing-1 text-uppercase color-base-100">
                                        {{"LoyaltyPoints" | translate}}
                                    </div>
                                    <button class="btn-dft-border mt-30">
                                        {{"REDEEMNOW" | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
            <div class="box-shadow bg-base-100 border border-color-900 text-align-center br-16 mt-50 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-18 letter-spacing-1 color-base-500">
                            {{"TotalPointsEarned" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 color-base-700 letter-spacing-3">
                            43,000
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="box-shadow bg-base-100 border border-color-900 text-align-center br-16 mt-16 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-18 letter-spacing-1 color-base-500">
                            {{"TotalPointsRedeemed" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 color-base-700 letter-spacing-3">
                            10,980
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="box-shadow bg-base-100 border border-color-900 text-align-center br-16 mt-16 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-18 letter-spacing-1 color-base-500">
                            {{"PointsExpiringNextMonth" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 color-base-700 letter-spacing-3">
                            530
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="box-shadow bg-base-100 border border-color-900 text-align-center br-16 mt-16 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-18 letter-spacing-1 color-base-500">
                            {{"PointsExpiringNext3Month" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 color-base-700 letter-spacing-3">
                            2,320
                        </div>
                    </grid-col>
                </grid-row>
            </div>
        </div>
    </div>
    <div class="post-login-2-col-3">
        <div class="pl-30 pr-30">
            <div class="font-600 font-size-20px line-h-40 color-base-1700">
                {{"ImtiazTitaniumCard" | translate }}
            </div>
            <grid-row class="justify-content-between align-item-center  mt-30">
                <grid-col col="auto">
                    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
                        {{"PointsHistory" | translate }}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-18 color-base-2200 letter-spacing-03 link-u">
                        {{"ViewAll" | translate}}
                    </div>
                </grid-col>
            </grid-row>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-16 p-15">
                <grid-row class="justify-content-between align-item-top link">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"SendMoney" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <!-- <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                            -1,000 Pts
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-top link mt-20">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"SendMoney" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            19/5 - 11:08AM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <!-- <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                            -1,000 Pts
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-top link mt-20">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"PAYCARD" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            16/5 - 10:28AM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            80 Pts
                        </div>
                        <!-- <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                            -1,000 Pts
                        </div> -->
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-top link mt-20">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"RedeemedPoints" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            19/5 - 2:28PM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <!-- <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                        80 Pts
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                            -1,000 Pts
                        </div>
                        <!-- <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                        EXP: 16 Dec 2025
                        </div> -->
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-top link mt-20">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"PAYCARD" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            20/5 - 10:28AM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                                            - {{"BHD" | translate}} 000
                                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            80 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <grid-row class="justify-content-between align-item-center mt-30">
                <grid-col col="auto">
                    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
                        {{"PointsHistory" | translate }}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <ng-icon iconClass="icon-filter-transaction link" width="24" height="24"
                        (click)="showModal(1)"></ng-icon>
                </grid-col>
            </grid-row>
            <grid-row class="justify-content-between mt-30">
                <grid-col col="auto">
                    <div class="bg-color-base-3200 pr-16 pl-16 br-40">
                        <span class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase">
                            September 2023
                        </span>
                        <ng-icon iconClass="icon-close-10px v-align-middle ml-10" width="10" height="10"></ng-icon>
                    </div>
                </grid-col>
            </grid-row>
            <div class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase mt-16">
                30 NOV
            </div>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 p-15">
                <grid-row class="justify-content-between align-item-top link">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"SendMoney" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase mt-16">
                19 NOV
            </div>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 p-15">
                <grid-row class="justify-content-between align-item-top link">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"SendMoney" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            5270 17•• •••• 4924
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase mt-16">
                16 NOV
            </div>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 p-15">
                <grid-row class="justify-content-between align-item-top link">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"RedeemedPoints" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            5270 17•• •••• 4924
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                            - {{"BHD" | translate}} 000
                        </div> -->
                        <!-- <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                            -1,000 Pts
                        </div>
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <div class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase mt-16">
                29 SEP
            </div>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 p-15">
                <grid-row class="justify-content-between align-item-top link">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                            {{"SendMoney" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-18 color-base-1900  letter-spacing-1 mt-5">
                            5270 17•• •••• 4924
                        </div>
                    </grid-col>
                    <grid-col col="auto" class="text-align-right">
                        <!-- <div class="font-600 font-size-14px line-h-20 color-error letter-spacing-2">
                                    - {{"BHD" | translate}} 000
                                </div> -->
                        <div class="font-600 font-size-14px line-h-20 color-success letter-spacing-2">
                            50 Pts
                        </div>
                        <!-- <div class="font-600 font-size-14px line-h-20 color-base-700 letter-spacing-2">
                                    -1,000 Pts
                                </div> -->
                        <div class="font-400 font-size-12px line-h-12 color-base-2000 mt-7">
                            EXP: 16 Dec 2025
                        </div>
                    </grid-col>
                </grid-row>
            </div>
        </div>
    </div>

    <!-- FILTER BY Month -->
    <modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="NEXT"
        [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="showModal(0)" modalHeading="FILTERBYMonth">
        <div class="text-align-center">

        </div>
    </modal>
    <!-- Points Redemption -->
    <modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="NEXT"
        [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="loyaltyPointsRadeem()"
        modalHeading="PointsRedemption">
        <div class="font-500 font-size-14px line-h-22 letter-spacing-1 coloe-base-1300">
            {{"PreferredTypeedemption" | translate}}
        </div>
        <div class="custom-radio-3 mt-30">
            <input type="radio" id="radio-1" name="radioGroup2">
            <label for="radio-1">
                <grid-row class="col-space-min align-item-center">
                    <grid-col col="auto">
                        <div class="font-500 font-size-14px line-h-20">
                            <ng-icon iconClass="icon-cash-back" width="24" height="24"></ng-icon>
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                            {{"cashback" | translate}}
                        </div>
                    </grid-col>
                </grid-row>
            </label>
        </div>
        <div class="custom-radio-3 mt-16">
            <input type="radio" id="radio-2" name="radioGroup2">
            <label for="radio-2">
                <grid-row class="col-space-min align-item-center">
                    <grid-col col="auto">
                        <div class="font-500 font-size-14px line-h-20">
                            <ng-icon iconClass="icon-gulf-air" width="32" height="32"></ng-icon>
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                            {{"TransferGulfAir" | translate}}
                        </div>
                    </grid-col>
                </grid-row>
            </label>
        </div>
        <div class="custom-radio-3 mt-16">
            <input type="radio" id="radio-3" name="radioGroup2">
            <label for="radio-3">
                <grid-row class="col-space-min align-item-center">
                    <grid-col col="auto">
                        <div class="font-500 font-size-14px line-h-20">
                            <ng-icon iconClass="icon-shukran" width="32" height="32"></ng-icon>
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                            {{"Shukran" | translate}}
                        </div>
                    </grid-col>
                </grid-row>
            </label>
        </div>
    </modal>